import { __rest } from 'tslib';
import { jsxs, jsx } from 'react/jsx-runtime';
import classNames from 'classnames';

var WiFiIllustration = function WiFiIllustration(_a) {
  var className = _a.className,
    _a$color = _a.color,
    color = _a$color === undefined ? 'sapphire' : _a$color,
    otherProps = __rest(_a, ["className", "color"]);
  return jsxs("svg", Object.assign({
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    "aria-label": "WiFiIllustration",
    role: "img",
    viewBox: "0 0 112 72",
    xmlns: "http://www.w3.org/2000/svg",
    width: "112",
    height: "72",
    fill: "none",
    className: classNames('cogs-illustration', 'cogs-themed-icon', className)
  }, otherProps, {
    children: [jsx("path", {
      fill: "var(--cogs-decorative--".concat(color, "--400)"),
      fillRule: "evenodd",
      d: "M25.483 29.568C33.556 21.215 44.531 16.5 56 16.5s22.444 4.715 30.517 13.068a3.5 3.5 0 0 1-5.034 4.864C74.703 27.418 65.535 23.5 56 23.5s-18.704 3.918-25.483 10.932a3.5 3.5 0 0 1-5.034-4.864m8 9C39.825 32.006 47.35 29.5 56 29.5s16.175 2.506 22.517 9.068a3.5 3.5 0 0 1-5.034 4.864C68.686 38.468 63.103 36.5 56 36.5s-12.686 1.968-17.483 6.932a3.5 3.5 0 0 1-5.034-4.864m10.086 6.914C46.886 42.28 51.359 40.5 56 40.5s9.114 1.779 12.431 4.982a3.5 3.5 0 1 1-4.862 5.036C61.582 48.598 58.86 47.5 56 47.5s-5.581 1.099-7.569 3.018a3.5 3.5 0 0 1-4.862-5.036",
      clipRule: "evenodd",
      opacity: ".3"
    }), jsx("g", {
      fill: "var(--cogs-decorative--".concat(color, "--400)"),
      opacity: ".5",
      children: jsx("path", {
        d: "M52 16a4 4 0 0 1 8 0v28a4 4 0 0 1-8 0zM52 56a4 4 0 1 1 8 0 4 4 0 0 1-8 0"
      })
    })]
  }));
};

export { WiFiIllustration };
